<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('staff_information')" :isFilter="false"  :is-back-button="true"
                        :back-button="backButton" :selected-menu="selectedMenu" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('staff_information')" :isFilter="false"  :is-back-button="true"
                              :back-button="backButton" :selected-menu="selectedMenu" />
            </template>
            <div class="d-flex flex-column flex-lg-row">
                <div class="mr-lg-5">
                    <info-page  :staffInformation="staffInformation" :edit-mode="true" :userId="staffInformation.user_id" />
                </div>
                <div class="mr-lg-5">
                    <menu-page v-model="selectedMenu" :menu-data="menuData"  />
                </div>
                <div class="flex-grow-1 w-100 w-lg-0" v-if="staffInformation">
                    <general-information v-if="selectedMenu === 'general_information'"  :staffInformation="staffInformation" @updatedData="getStudent" />
                    <emergencyContactInformation v-if="selectedMenu === 'emergency_contact_information'" @updatedData="getStudent" :studentProgram="studentProgram" :staffInformation="staffInformation"  :editMode="editMode" />
                    <documents v-if="selectedMenu ==='documents'" />
                    <Adjunct v-if="selectedMenu ==='adjunct'" :user-id="staffInformation.user_id" />
                    <CourseInformation v-if="selectedMenu ==='course_information'" :user-id="staffInformation.user_id" :can-teach-courses="staffInformation.courses_instructor_can_teach" @updatedData="getStudent" />
                    <HrInformation v-if="selectedMenu ==='hr_information'" :staff-information="staffInformation" @updatedData="getStudent" />

                </div>
            </div>
            <CommonModal ref="DocumentModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('documents').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div class="mb-2 border rounded p-2 text-center bg-dark text-white">
                        {{ user.student_number }} - {{ user.name }} {{ user.surname }}
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="UserInfoModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('username_info_update').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ValidationObserver ref="usernameForm">
                        <b-row>
                            <b-col md="6">
                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('name')">
                                        <b-form-input v-model="usernameForm.name" :class="errors[0] ? 'is-invalid' : ''">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('surname')">
                                        <b-form-input v-model="usernameForm.surname" :class="errors[0] ? 'is-invalid' : ''">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="12" class="mb-4">
                                <b-form-checkbox v-model="usernameForm.manuel" name="check-button" switch>
                                    {{ $t('username_update_manuel_switch') }}
                                </b-form-checkbox>
                            </b-col>
                            <b-col md="6" v-if="usernameForm.manuel">
                                <ValidationProvider name="username" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('username')">
                                        <b-form-input v-model="usernameForm.username"
                                                      :class="errors[0] ? 'is-invalid' : ''">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="12">
                                <b-button @click="changeUsername" variant="primary">{{ $t('change') }}</b-button>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </template>
            </CommonModal>
            <CommonModal ref="addSemester" size="xl">
                <template v-slot:CommonModalTitle>
                    {{ $t('semester_add').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="semesterForm">
                            <b-row>
                                <b-col md="6">
                                    <ValidationProvider name="semester" rules="required" v-slot="{ errors }">
                                        <b-form-group :label="$t('semester')">
                                            <semesters-selectbox :validate-error="errors[0]"
                                                                 v-model="semesterForm.semester_id"></semesters-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="6">
                                    <ValidationProvider name="semester_status" rules="required" v-slot="{ errors }">
                                        <b-form-group :label="$t('semester_status')">
                                            <parameter-selectbox :validate-error="errors[0]" code="semester_statuses"
                                                                 v-model="semesterForm.semester_status"></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="6">
                                    <ValidationProvider name="class" rules="required" v-slot="{ errors }">
                                        <b-form-group :label="$t('class')">
                                            <parameter-selectbox :validate-error="errors[0]" code="classes"
                                                                 v-model="semesterForm.class"></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="12">
                                    <b-button @click="addSemester" variant="primary">{{ $t('semester_add') }}</b-button>
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'


import InfoPage from './InfoPage';
import MenuPage from './MenuPage';
import generalInformation from "@/modules/staff/pages/Information/components/generalInformation/Index.vue"
import emergencyContactInformation from "@/modules/staff/pages/Information/components/emergencyContactInformation/Index.vue"
import Documents from  "@/modules/staff/pages/Information/components/documents/Index.vue"
import Adjunct from "@/modules/staff/pages/Information/components/Adjunct/Index.vue"
import CourseInformation from "@/modules/staff/pages/Information/components/CourseInformation/Index.vue"
import HrInformation from "@/modules/staff/pages/Information/components/hrInformation/Index.vue"


// Services
import StudentSemesterService from '@/services/StudentSemesterService';

// Data
import menuData from '@/modules/staff/pages/data/Menus';

// Component
import CommonModal from '@/components/elements/CommonModal';
import { EventBus } from '@/main'
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox"
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import UserService from "../../../../services/UserService";
import StaffService from "@/services/StaffService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        generalInformation,
        Documents,
        emergencyContactInformation,
        ValidationObserver,
        ValidationProvider,
        InfoPage,
        MenuPage,
        Adjunct,
        SemestersSelectbox,
        ParameterSelectbox,
        CourseInformation,
        HrInformation,
        CommonModal,
    },
    metaInfo() {
        return {
            title: this.$t('staff')
        }
    },
    data() {
        return {
            staffId: null,
            studentProgram: {},
            user: {},
            staffInformation:{
                    // Tab 1
                    id:null,
                    user_id:null,
                    username: null,
                    registration_number: null,
                    title: null,
                    name: null,
                    surname: null,
                    email: null,
                    mobile_tel: null,
                    courses_instructor_can_teach:null,

                    faculty_code: null,
                    department_code: null,
                    academic_department_code: null,
                    program_code: null,
                    campus_id: null,
                    building_id: null,
                    unit_id: null,
                    office: null,

                    contract_type: null,
                    working_status: null,
                    start_date: null,
                    end_date: null,

                    employee_id: null,
                    job_title: null,
                    supervisor_id: null,
                    supervisor_name: null,
                    budgetary_department: null,
                    budgetary_department_name: null,
                    is_leadership_team: false,
                    is_purchase_officer: false,

                    // Tab 2
                    father_name: null,
                    mother_name: null,
                    birthdate: null,
                    nationality_code: null,
                    gender: null,
                    mobile_tel_country_code: null,
            },
            usernameForm: {
                name: null,
                surname: null,
                username: null,
                manuel: false
            },
            formProcess: null,
            menuData: null,
            selectedMenu: 'general_information',
            actions: [
                {
                    text: this.$t('payment_info'),
                    class: 'ri-money-dollar-circle-line',
                    permission: 'customer_customerpayments',
                    callback: () => {
                        this.$router.push('/customers/payments/student/' + this.studentProgram.id);
                    }
                },
                {
                    text: this.$t('course_registration'),
                    class: 'ri-book-line',
                    permission: 'courseregistration_getslot',
                    callback: () => {
                        this.$router.push('/course/registration/' + this.studentProgram.id)
                    }
                },
                {
                    text: this.$t('slots'),
                    class: 'ri-list-check',
                    permission: 'studentprogram_studentslot',
                    callback: () => {
                        this.$router.push('/student/programs/' + this.studentProgram.id + '/slots')
                    }
                },
                {
                    text: this.$t('documents'),
                    class: 'ri-file-list-line',
                    permission: 'studentprogram_show',
                    callback: () => {
                        this.showDocumentModal();
                    }
                },
                {
                    text: this.$t('username_info_update'),
                    class: 'ri-shield-user-line',
                    permission: 'user_updatepersonalinformation',
                    callback: () => {
                        this.showUserInfoModal();
                    }
                },
                {
                    text: this.$t('semester_add'),
                    permission: 'studentsemester_store',
                    callback: () => {
                        this.$refs.addSemester.$refs.commonModal.show()
                    }
                }
            ],
            editMode: true,

            masks: {
                input: "MM/DD/YYYY",
            },
            semesterForm: {}
        }
    },
    async created() {
        this.staffId = this.$route.params.id;
        if (this.staffId) {
            await this.getStudent()
            this.menuData = menuData(null, this.staffInformation);
            this.selectedDefaultValue()
        } else {
            this.$router.push('/404');
        }


    },
    computed: {
        computeDropdownMenuName: {
            get() {
                let selected = (this.menuData || []).find(item => item.slug == this.selectedMenu)
                return selected ? this.toUpperCase(selected.title) : '';
            },
            set() {

            }
        },
    },
    methods: {
        getStudent() {
            return StaffService.get(this.staffId)
                .then(response => {
                    let data = response.data.data;
                    this.staffInformation.registration_number = data.registration_number
                    this.staffInformation.title = data.title
                    this.staffInformation.user_id = data.user_id
                    this.staffInformation.id = data.id
                    this.staffInformation.courses_instructor_can_teach=data.courses_instructor_can_teach?data.courses_instructor_can_teach:[]
                    if (data.person) {
                        this.staffInformation.username = data.person.username
                        this.staffInformation.name = data.person.name
                        this.staffInformation.surname = data.person.surname
                        this.staffInformation.email = data.person.email
                        this.staffInformation.personal_email = data.person.personal_email
                        this.staffInformation.mobile_tel = data.person.mobile_tel
                        this.staffInformation.mobile_tel_country_code = data.person.mobile_tel_country_code
                    }
                    this.staffInformation.faculty_code = data.faculty_code
                    this.staffInformation.department_code = data.department_code
                    this.staffInformation.academic_department_code = data.academic_department_code
                    this.staffInformation.program_code = data.program_code
                    this.staffInformation.campus_id = data.campus_id
                    this.staffInformation.building_id = data.building_id
                    this.staffInformation.unit_id = data.unit_id
                    this.staffInformation.office = data.office

                    this.staffInformation.contract_type = data.contract_type
                    this.staffInformation.working_status = data.working_status
                    this.staffInformation.start_date = data.start_date
                    this.staffInformation.end_date = data.end_date

                    this.staffInformation.employee_id = data.employee_id
                    this.staffInformation.job_title = data.job_title
                    this.staffInformation.job_title_name = data.job_title_name
                    this.staffInformation.supervisor_id = data.supervisor_id
                    this.staffInformation.supervisor_name = data.supervisor_name
                    this.staffInformation.budgetary_department = data.budgetary_department
                    this.staffInformation.budgetary_department_name = data.budgetary_department_name
                    this.staffInformation.is_leadership_team = data.is_leadership_team
                    this.staffInformation.is_purchase_officer = data.is_purchase_officer
                    if (data.person) {
                        this.staffInformation.father_name = data.person.father_name
                        this.staffInformation.mother_name = data.person.mother_name
                        this.staffInformation.birthdate = data.person.birthdate
                        this.staffInformation.nationality_code = data.person.nationality_code
                        this.staffInformation.gender = data.person.gender
                        this.staffInformation.emergency_person_relation=data.person.emergency_person_relation
                        this.staffInformation.emergency_person_name=data.person.emergency_person_name
                        this.staffInformation.emergency_person_phone=data.person.emergency_person_phone
                    }
                })
                .catch(() => {
                    this.$router.push('/404')
                })
        },
        backButton() {
            this.$router.push('/staff');
        },

        // Clear
        formClear() {
            this.formProcess = null
        },

        // Documents
        showDocumentModal() {
            this.$refs.DocumentModal.$refs.commonModal.show()
        },

        selectedDefaultValue() {
            let selected = this.menuData.find(item => item.slug == this.selectedMenu)
            this.computeDropdownMenuName = selected ? this.toUpperCase(selected.title) : '';
        },
        showUserInfoModal() {
            this.usernameForm.name = this.user.name
            this.usernameForm.surname = this.user.surname
            this.$refs.UserInfoModal.$refs.commonModal.show()
        },

        async changeUsername() {
            const isValid = await this.$refs.usernameForm.validate();
            if (isValid) {
                let formData = {
                    name: this.usernameForm.name,
                    surname: this.usernameForm.surname
                }
                this.usernameForm.manuel ? formData.username = this.usernameForm.username : null
                UserService.updatePersonalInformation(formData, this.studentProgram.user_id).then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message))
                    this.$refs.UserInfoModal.$refs.commonModal.hide()
                }).catch(e => {
                    this.showErrors(e, this.$refs.usernameForm)
                })
            }
        },

        async addSemester() {
            const isValid = await this.$refs.semesterForm.validate()

            if (isValid) {
                this.semesterForm.student_program_id = this.user.id

                StudentSemesterService.store(this.semesterForm)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.$emit('actionSuccess', true)

                        this.$refs.addSemester.$refs.commonModal.hide()
                    })
                    .catch((error) => {
                        if (error.status == 422) {
                            if (error.data.errors.student_program_id) {
                                this.$refs.semesterForm.errors.semester.push(error.data.errors.student_program_id[0])
                            }
                        }
                        else {
                            this.$toast.error(this.$t('api.' + error.data.message))
                        }
                    })

            }
        }
    },
    mounted() {
        EventBus.$on('closeDocumentModal', () => {
            this.$refs.DocumentModal.$refs.commonModal.hide()
        })
    }
}
</script>

